import styled from '@emotion/styled';
import { Grid } from '@mui/material';

export const DashboardStyled = {
  MainContainer: styled.div`
    display: flex;
    flex-direction: column;
    max-width: 100vw;
  `,
  SidebarAndContentContainer: styled(Grid) <any>`
    display: flex;
    flex-direction: row;
    margin-top: 60px;
  `,
};
